import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { RhfCheckbox, RhfSelect, RhfDatePicker, RhfRadioGroup, RhfSwitch, RhfTextField } from '../../components/Inputs';
import Button from '@mui/material/Button';
import MenuItem from '@mui/material/MenuItem';
import { z } from 'zod';
import Typography from '@mui/material/Typography';

export const UserSchema = z
  .object({
    name: z.string('Name is required').trim().min(1, 'Name is required'),
    favouriteColor: z.string('Favourite color is required').trim().min(1, 'Favourite color is required'),
    favouriteAnimal: z.string('Favourite animal is required').trim().min(1, 'Favourite animal is required'),
    startDate: z
      .date({ required_error: 'Start date is required' })
      .nullable()
      .refine((val) => val !== null, 'Start date is required')
      .refine((val) => {
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        return val >= today;
      }, 'Must be today or later'),
    endDate: z
      .date({ required_error: 'End date is required' })
      .nullable()
      .refine((val) => val !== null, 'End date is required'),
    mailingList: z.boolean(),
    enableFeature: z.boolean(),
  })
  .refine(({ startDate, endDate }) => !startDate || !endDate || endDate >= startDate, {
    message: 'End date must be on or after the start date',
    path: ['endDate'],
  });

const FormPlayground = () => {
  const { control, handleSubmit, watch, reset, formState } = useForm({
    resolver: zodResolver(UserSchema),
    defaultValues: {
      name: '',
      favouriteColor: '',
      favouriteAnimal: '',
      startDate: null,
      endDate: null,
      mailingList: false,
      enableFeature: false,
    },
  });

  const onSubmit = (data) => {
    console.log('Form submitted:', data);
  };

  return (
    <div style={{ display: 'flex', width: '900px', gap: '15px', margin: '0 auto' }}>
      <div className="component-playground">
        <form onSubmit={handleSubmit(onSubmit)} onReset={() => reset()}>
          <div className="mb-4">
            <RhfTextField
              name="name"
              control={control}
              label="Name"
              placeholder="Enter your name"
              tooltip="This is a tooltip"
            />
          </div>
          <div className="mb-4">
            <RhfDatePicker
              name="startDate"
              control={control}
              label="Start Date"
              placeholder="Select your start date"
              tooltip="This is a tooltip"
            />
          </div>
          <div className="mb-4">
            <RhfDatePicker
              name="endDate"
              control={control}
              label="End Date"
              placeholder="Select your end date"
              tooltip="This is a tooltip"
            />
          </div>
          <div className="mb-4">
            <RhfSelect
              name="favouriteColor"
              control={control}
              label="Favourite Color"
              placeholder="Select your favourite color"
              tooltip="This is a tooltip"
            >
              <MenuItem value="red">Red</MenuItem>
              <MenuItem value="blue">Blue</MenuItem>
              <MenuItem value="green">Green</MenuItem>
            </RhfSelect>
          </div>
          <div className="mb-4">
            <RhfRadioGroup
              name="favouriteAnimal"
              control={control}
              label="Favourite Animal"
              buttons={[
                {
                  label: 'Dog',
                  value: 'dog',
                },
                {
                  label: 'Cat',
                  value: 'cat',
                },
                {
                  label: 'Bird',
                  value: 'bird',
                },
              ]}
            />
          </div>
          <div className="mb-4">
            <RhfCheckbox name="mailingList" control={control} label="Subscribe to mailing list?" />
          </div>
          <div className="mb-4">
            <RhfSwitch name="enableFeature" control={control} label="Enable feature" />
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Button type="reset" variant="contained" color="secondary">
              Reset
            </Button>
            <Button type="submit" variant="contained" color="primary">
              Submit
            </Button>
          </div>
        </form>
      </div>
      <div style={{ backgroundColor: '#f5f5f5', padding: '1rem', flex: 1, minWidth: 350 }}>
        <h3>Form Data Preview:</h3>
        <pre>{JSON.stringify(watch(), null, 2)}</pre>
        {formState.isSubmitSuccessful && (
          <Typography sx={(theme) => ({ py: theme.spacing(3) })}>Form submitted successfully!</Typography>
        )}
      </div>
    </div>
  );
};

export default FormPlayground;
